import { useEffect } from 'react';
import GTM from 'react-gtm-module';

let initialized = false;

const useGoogleTagManager = () => {
  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM;

    if (!gtmId) {
      return;
    }

    GTM.initialize({ gtmId });

    if (!initialized) {
      // Track basic JavaScript errors
      // eslint-disable-next-line func-names
      window.addEventListener('error', function (e) {
        GTM.dataLayer({
          dataLayer: {
            event: 'error',
            message: e.message,
            stacktrace: e.error?.stack,
            path: window.location.pathname,
          },
        });
      });

      initialized = true;
    }

    if (!initialized) {
      throw new Error('GTM is not initialized');
    }
  }, []);
};

export { useGoogleTagManager };
